
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextPage } from 'next';
import * as prismic from '@prismicio/client';
import { PageProps, ServerSideProps } from 'types/pages';
import { BlogItem } from 'pages/api/blogApi.types';
import { mapObjectToQueryString } from 'helpers/url';
import { mapNextLocaleToISOLanguageCode } from 'helpers/locale.helper';
import { fetchBlogs } from 'prismic/api/blogs';
import { PRISMIC_CUSTOM_TYPES } from 'prismic/config';
import { client, fetchDocuments } from 'prismic/helpers/fetchContent';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import BlogsTemplate from 'components/templates/BlogsTemplate';

const { page, header, footer } = PRISMIC_CUSTOM_TYPES;

interface BlogOverviewProps extends PageProps {
  blogs: BlogItem[];
}

const BlogOverview: NextPage<BlogOverviewProps> = ({ header, data, footer, blogs }) => {
  return <BlogsTemplate data={data} header={header} footer={footer} blogs={blogs} />;
};

 async function _getServerSideProps({ locale, params, query, res }: ServerSideProps) {
  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=60');

  const { domain } = params;

  const isoLangCode = mapNextLocaleToISOLanguageCode(locale);

  const documentRelations = await getDocumentRelationsFromFile();

  // Get page data
  let fetchedContent;

  const documents = await fetchDocuments({ pageType: 'blog_ubersicht', lang: isoLangCode });

  if (documents.length > 1) {
    fetchedContent = documents.find((docItem) => {
      return docItem.tags.includes(domain);
    });
  } else {
    fetchedContent = documents[0];
  }

  // Get Header and footer
  const [headerData, footerData] = await Promise.all([
    client.getFirst({
      lang: isoLangCode,
      predicates: [
        prismic.predicate.at('document.tags', [domain]),
        prismic.predicate.at('document.type', header),
      ],
    }),
    client.getFirst({
      lang: isoLangCode,
      predicates: [
        prismic.predicate.at('document.tags', [domain]),
        prismic.predicate.at('document.type', footer),
      ],
    }),
  ]);

  const fetchedContentHeaderFooter = {
    header: headerData,
    footer: footerData,
    domain,
    type: page,
  };

  // Get Event boxes data
  let blogs: BlogItem[] = [];

  try {
    let queryString = '';
    if (query) {
      const queryObj = { ...query };
      queryObj.locale = isoLangCode;
      queryString = mapObjectToQueryString(queryObj);
    }

    const blogsResponse = await fetchBlogs({ domain, query: queryString });

    blogs = blogsResponse.data.items || [];
  } catch (error) {
    console.error('[Blog] fetch events error', error);
  }

  // Return Error page if no content
  const is404 = !fetchedContent;

  if (is404) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      data: { ...fetchedContent },
      ...fetchedContentHeaderFooter,
      sharedData: null,
      documentRelations,
      blogs: blogs,
    } as BlogOverviewProps,
  };
}

export default BlogOverview;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/blog/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  